import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { GoogleSignInButton } from "../components/GoogleSignInButton";

export const Register = () => {
    const { register } = useAuth();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await register(form);
            toast.success("Καλωσήρθες στο Grill Bros!");
            navigate("/");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Σφάλμα εγγραφής");
        } finally {
            setLoading(false);
        }
    };

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    return (
        <div className="mx-auto max-w-md px-4 sm:px-8 py-20" data-testid="register-page">
            <h1 className="headline text-4xl mb-2">Εγγραφή</h1>
            <p className="text-white/60 mb-8 text-sm">Δημιούργησε λογαριασμό σε λιγότερο από ένα λεπτό.</p>

            <GoogleSignInButton label="Εγγραφή με Google" />

            <div className="flex items-center gap-3 my-6">
                <div className="flex-1 h-px bg-white/10" />
                <span className="text-xs uppercase tracking-widest text-white/40">ή</span>
                <div className="flex-1 h-px bg-white/10" />
            </div>

            <form onSubmit={submit} className="space-y-4">
                <input required data-testid="register-name" placeholder="Ονοματεπώνυμο" value={form.name} onChange={set("name")}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 rounded-sm focus:outline-none focus:border-brand-red" />
                <input required type="email" data-testid="register-email" placeholder="Email" value={form.email} onChange={set("email")}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 rounded-sm focus:outline-none focus:border-brand-red" />
                <input data-testid="register-phone" placeholder="Τηλέφωνο" value={form.phone} onChange={set("phone")}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 rounded-sm focus:outline-none focus:border-brand-red" />
                <input required type="password" minLength={6} data-testid="register-password" placeholder="Κωδικός (τουλ. 6 χαρακτήρες)" value={form.password} onChange={set("password")}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 rounded-sm focus:outline-none focus:border-brand-red" />
                <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full">
                    {loading ? "Δημιουργία..." : "Δημιουργία λογαριασμού"}
                </button>
            </form>
            <p className="text-sm text-white/60 mt-6">
                Έχεις λογαριασμό; <Link to="/login" className="text-brand-red hover:underline">Σύνδεση</Link>
            </p>
        </div>
    );
};
